<div class="sidebar-section">
    <div class="sidebar-toggle-section">
      <mat-slide-toggle [(ngModel)]="sidebarOnRight" (change)="toggleSidebarPosition()" 
                        class="sidebar-slide-toggle " [color]="toggleColor">
        {{ sidebarTitle }}
      </mat-slide-toggle>
    </div>
  </div>